import React from 'react';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import BranchesForm from './form';
export default function BranchesUpdate(props) {
    const { id } = props.match.params;
    return (
        <div>
            <MyBreadcrumb items={[{ label: "Branches", path: "/branches" }, { label: "Update", path: "" }]} />
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Update"
                subTitle=""
            >
                <BranchesForm id={id} />
            </PageHeader>
        </div>
    );
}